import { REACT_APP__IS_FOREIGN, REACT_APP__URL_STORAGE_STATIC, } from "@smp/utils";
export const apiStorageSmpStaticsEmojisDataRetrieve = () => fetch(`${REACT_APP__URL_STORAGE_STATIC}/emojis/v4/data.json`)
    .then((res) => res.json())
    .then((data) => {
    if (!REACT_APP__IS_FOREIGN) {
        data.categories["Flags"] = data.categories["Flags"].filter((unified) => unified !== "1f3f3-fe0f-200d-1f308");
        delete data.emojis["1f3f3-fe0f-200d-1f308"];
    }
    return data;
});
//# sourceMappingURL=data.js.map